export default __webpack_public_path__ + "static/media/arrow_back_fill.8c9316dc.svg";